import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderRequest } from './../header-request';
import { LineRequest } from './../line-request';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { updateRequestValue } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-requests',
    templateUrl: './edit-requests.component.html',
    styleUrls: ['./edit-requests.component.scss'],
})
export class EditRequestsComponent implements OnInit {
    public selectedRequest: HeaderRequest;
    public selectedItem: LineRequest;
    public requestResult: any[];
    public requestItem: any[] = [];

    @Input()
    public item: any;

    @Input()
    public indexList = [];
    @Input()
    public systemList = [];
    @Input()
    public propertiesList = [];
    @Input()
    public propBskList = [];

    @Input()
    public editorList = [];

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public resultList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.selectedItem = new LineRequest();
        this.selectedRequest = new HeaderRequest();
    }

    ngOnInit() {
        this.getRequest(this.item.id);
        this.commonService.checkReset();
    }

    private async getRequest(id) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getrequest', id ));
            this.requestResult = wRes[0];
            this.selectedRequest.Clear();
            if (id !== 0) {
                this.loadRequestData(this.requestResult);
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private loadRequestData(adata) {
        this.selectedRequest.load(adata);
        this.requestItem = [...this.selectedRequest.reqDetail];
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(request) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        if (request.duplicate === true) {
            request.entete.id = 0;
        }
        const wParams = updateRequestValue(request.entete, request.detail);

        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updaterequest', wParams ));
            this.onValidate.emit({
                index: this.item.index,
                id: this.item.id,
                data: wRes.data,
                duplicate: request.duplicate,
            });                
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }     
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
